import { onSuccess } from "../messages";
import useAppSelector from "./useAppSelector";
import useCloseHandler from "./useCloseHandler";
import useEventPublisher from "./useEventPublisher";
export default function useHandleAuthValid() {
    var eventPublisher = useEventPublisher();
    var _a = useAppSelector(function (state) { return state.applicant; }), currentIssuer = _a.currentIssuer, savvyConnectionIdFromState = _a.savvyConnectionId;
    var _b = useAppSelector(function (state) { return state.configuration; }), isSavvyWidget = _b.isSavvyWidget, authOnly = _b.authOnly;
    var handleClose = useCloseHandler();
    var accountInfo = useAppSelector(function (state) { return state.auth; }).auto.accountInfo;
    var connectionId = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.connectionId;
    var temporaryAccessKey = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.temporaryAccessKey;
    return function handleAuthValid(_a) {
        var _b = _a === void 0 ? {} : _a, savvyConnectionId = _b.savvyConnectionId;
        var metadata = {
            issuer: currentIssuer.auto,
            temporaryAccessKey: temporaryAccessKey,
        };
        if (isSavvyWidget) {
            metadata.connectionId = savvyConnectionId || savvyConnectionIdFromState;
        }
        onSuccess(connectionId, metadata);
        eventPublisher.authComplete();
        if (authOnly) {
            handleClose();
        }
    };
}
